/**
 * Lighthouse table header label: `[MEMBER ID]` style.
 * Shared by ParticipantTable and any admin MUI table.
 */
export function formatTableHeader(label) {
  const text = String(label || '').trim();
  if (!text) return '';
  if (text.startsWith('[') && text.endsWith(']')) return text;
  return `[${text.toUpperCase()}]`;
}
